export default __webpack_public_path__ + "static/banner_contact-90bdb549f8a02a5f49b4eb74a20c8365.png";